import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/database'

const config ={
  apiKey: "AIzaSyAdLX9JoVfNqbWW0cl-B9IKhjts6RqkSZg",
  authDomain: "biocidiedukacija.firebaseapp.com",
  databaseURL: "https://biocidiedukacija.firebaseio.com",
  projectId: "biocidiedukacija",
  storageBucket: "biocidiedukacija.appspot.com",
  messagingSenderId: "995728584405",
  appId: "1:995728584405:web:1707150db93e92decbfc5c"
  };
  firebase.initializeApp(config);


  export const createUserProfileDocument = async (userAuth,additionalData) =>{
    if (!userAuth)return;

const userRef=firestore.doc(`users/${userAuth.uid}`);


const snapShot= await userRef.get();

if (!snapShot.exists){
  const {displayName,ID,email}=userAuth;
  const createdAt= new Date();

  try{
 await userRef.set({
   displayName,
   ID,
   email,
   createdAt,
   ...additionalData
 })
  }
  catch(error){
    console.log('error creating user',error.message);

  }
  
}
return userRef;

  };

 




  export const auth = firebase.auth();
  export const firestore=firebase.firestore();

  const provider = new firebase.auth.GoogleAuthProvider();
  provider.setCustomParameters({ prompt : 'select_account' });
  export const signInWithGoogle =()=> auth.signInWithPopup(provider);

  export default firebase;
